import { Type } from '@angular/core';
import { ToastBaseComponent, ToastType } from './toast.type';
import { SuccessToastComponent } from './success-toast/success-toast.component';
import { WarningToastComponent } from './warning-toast/warning-toast.component';
import { ErrorToastComponent } from './error-toast/error-toast.component';
import { MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';

export const TOAST_COMPONENT_REF: { [c in ToastType]: Type<ToastBaseComponent> } = {
  success: SuccessToastComponent,
  warning: WarningToastComponent,
  danger: ErrorToastComponent,
} as const;

export const TOAST_POSITION: { [c in ToastType]: MatSnackBarHorizontalPosition } = {
  success: 'center',
  danger: 'right',
  warning: 'right',
};

export const TOAST_PANEL_CLASS: { [c in ToastType]: string } = {
  success: 'success-toast',
  danger: 'error-toast',
  warning: 'warning-toast',
};

export const TOAST_DEFAULT_DURATION = 8000;
